var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeIconMonochromeDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M180.32,52.76A22.12,22.12,0,0,0,164.76,37.1C151,33.4,96,33.4,96,33.4s-55,0-68.76,3.7A22.12,22.12,0,0,0,11.68,52.76C8,66.58,8,95.4,8,95.4S8,124.22,11.68,138A22.12,22.12,0,0,0,27.24,153.7C41,157.4,96,157.4,96,157.4s55,0,68.76-3.7A22.12,22.12,0,0,0,180.32,138C184,124.22,184,95.4,184,95.4S184,66.58,180.32,52.76ZM78,121.57V69.23L124,95.4Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIconMonochromeDark);
export default __webpack_public_path__ + "static/media/youtube-icon-monochrome-dark.750c0acaf7b5b406ef916f82c6ef356e.svg";
export { ForwardRef as ReactComponent };